import {routes} from './routes';
import EvaluationsService from "./service";
import EvaluationsInsertController from "./insert/controller";

export default angular.module('app.evaluations', [])
  .config(routes)
  .service('EvaluationsService', EvaluationsService)
  .controller('EvaluationsInsertController', EvaluationsInsertController)
  .name;
